export default function setViewingTour({ state }, tourId) {
  const viewingTour = state.get(['agentMapView', 'viewingTour']);
  if (viewingTour && viewingTour.id === tourId) {
    return;
  }

  const tours = state.get(['agent', 'tours']);
  const tour = tours.find(({ id }) => id === tourId);

  state.set(['agentMapView', 'mapChanged'], false);
  state.set(['agentMapView', 'mapZoomLevel'], 11);
  state.set(['agentMapView', 'viewingTour'], tour);
  state.set(['agentMapView', 'viewingRenter'], tour.users[0]);
  state.set(['agentMapView', 'viewingRenterSearchFilters'], tour.users[0].searchFilters);
  state.set(['agentMapView', 'listings'], tour.listings);
}
